import React from "react";
import { BadgeCheck, Landmark, Sparkles } from "lucide-react";
import { useStore } from "@/store/StoreContext";

const ICONS = [BadgeCheck, Landmark, Sparkles];

export default function ValueSection() {
  const { content, showcase } = useStore();
  const POINTS = showcase.value_point || [];
  if (!POINTS.length) return null;
  return (
    <section data-testid="value-section" className="relative mx-auto max-w-7xl px-5 py-12 sm:px-8 lg:py-16">
      <div className="reveal mb-9 text-center">
        <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{content?.value_eyebrow || "The Rudralife Promise"}</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl">
          {content?.value_title || "Why Seekers Trust Rudralife"}
        </h2>
        <p className="font-display mx-auto mt-4 max-w-2xl text-lg italic leading-relaxed text-[#6B5B45]">
          {content?.value_text}
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-3">
        {POINTS.map((pt, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
          <div key={pt.id || pt.name} data-testid={`value-point-${i}`} className="reveal rounded-md border border-[#E9DFC8] bg-white p-7 text-center" style={{ transitionDelay: `${i * 90}ms` }}>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#D4AF37]/15">
              <Icon className="h-5 w-5 text-[#8F6E1D]" />
            </div>
            <h3 className="font-display text-xl font-semibold text-[#2B1E12]">{pt.name}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#6B5B45]">{pt.text}</p>
          </div>
          );
        })}
      </div>
    </section>
  );
}
